module.exports = __webpack_public_path__ + "img/人参.4858587e.jpg";